"use strict";

exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var rbac_1 = require("./rbac");
var generateAppConfig = function (user) {
  if (utils_1.getIsRbacUser(user)) {
    return rbac_1["default"](user);
  }
  var config = {};
  var gates = user.gates,
    roles = user.roles,
    scopes = user.scopes;
  var isBotsV2User = utils_1.getIsBotsV2User(gates);
  var needsToUpgradeForMarketo = ramda_1.pathOr(false, ['marketo_prompt_upgrade'], gates);
  var orgHasAudiences = !!gates.AUDIENCE;
  var isAdmin = utils_1.getIsOrgAdmin(scopes);
  var isChatUser = utils_1.getIsChatUser(scopes);
  var isPlaybooksUser = utils_1.getIsPlaybooksUser(roles);
  // Visitors Nav
  config = ramda_1.set(ramda_1.lensProp('hasAudiences'), orgHasAudiences && !isBotsV2User && (isAdmin || isPlaybooksUser), config);
  config = ramda_1.set(ramda_1.lensProp('hasContacts'), isChatUser || isAdmin || isPlaybooksUser || isBotsV2User, config);
  config = ramda_1.set(ramda_1.lensProp('hasAccounts'), !isBotsV2User && (isAdmin || isPlaybooksUser || isChatUser), config);
  config = ramda_1.set(ramda_1.lensProp('hasLiveView'), !isBotsV2User && (isChatUser || isAdmin || isPlaybooksUser), config);
  // Contacts-web
  config = ramda_1.set(ramda_1.lensProp('hasEnrollInSequence'), !isBotsV2User, config);
  config = ramda_1.set(ramda_1.lensProp('hasSendMessageButton'), !isBotsV2User, config);
  if (isBotsV2User) {
    config = ramda_1.set(ramda_1.lensProp('hasMarketoAccess'), true, config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('hasMarketoAccess'), !needsToUpgradeForMarketo, config);
  }
  return config;
};
exports["default"] = generateAppConfig;